import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { FormikProps } from 'formik';
import React, { useCallback } from 'react';

import { Box, FieldError, Flex, Text } from '~/components/blocks';
import { Checkbox } from '~/components/partials/PatientBlocks/Checkbox';
import { PATIENT_PRIVACY_POLICY_URL, PATIENT_TERM_URL } from '~/constants/urls';

import { Fields } from '../types';

type Props = {
  formikProps: FormikProps<Fields>;
};

const TermsLink = styled('a')(({ theme }) =>
  css({
    color: theme.colors.text.patientLinkBluePurple,
    textDecoration: 'underline',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  }),
);

export const TermAndPrivacyField = React.memo((props: Props) => {
  const { formikProps } = props;
  const theme = useTheme();

  const handleOpenTerm = useCallback(
    () => window.open(PATIENT_TERM_URL, '_blank', 'noopener,noreferrer'),
    [],
  );

  const handleOpenPrivacy = useCallback(
    () => window.open(PATIENT_PRIVACY_POLICY_URL, '_blank', 'noopener,noreferrer'),
    [],
  );

  return (
    <>
      <Box>
        <Flex alignItems="center" justifyContent="center" mt={theme.space.l}>
          <Checkbox name="isAgree" onChange={formikProps.handleChange} />
          <Text ml={theme.space.s} size="m">
            <TermsLink onClick={handleOpenTerm}>利用規約</TermsLink>
            および
            <TermsLink onClick={handleOpenPrivacy}>プライバシーポリシー</TermsLink>
            に同意する
          </Text>
        </Flex>
        {formikProps.errors.isAgree && <FieldError error={formikProps.errors.isAgree} />}
      </Box>
    </>
  );
});

TermAndPrivacyField.displayName = 'TermAndPrivacyField';
